<template>
  <div class="border-t border-[#DDE6EF] bg-[#F7F9FB] pt-12 lg:pt-16 pb-12">
    <div class="px-4 lg:px-10">
      <div class="flex justify-center lg:justify-between items-left flex-wrap">
        <div class="hidden lg:flex gap-x-4">
          <router-link :to="{ name: 'landing' }">
            <img class="h-10 md:h-12" :src="logo" alt="" />
          </router-link>
          <LanguageSwitch />
        </div>
        <div>
          <div class="flex gap-8 lg:gap-20 flex-wrap justify-between">
            <div
              v-for="(items, footerHeading) in footerData"
              :key="footerHeading"
            >
              <div
                class="flex font-semibold lg:font-bold text-[#98A2B3] lg:text-[#6E6E6E] text-body-md mb-4 w-32 lg:w-min capitalize"
              >
                {{ $t(`footer.${footerHeading}`, footerHeading) }}
              </div>
              <div class="flex flex-col gap-3">
                <div v-for="(item, index) in items" :key="index">
                  <div
                    class="text-left text-body-md lg:text-body-sm text-[#6E6E6E] lg:text-[#344054] flex capitalize"
                  >
                    <router-link v-if="item?.to" :to="item.to">
                      {{ $t(`footer.${item.name}`, item.name) }}
                    </router-link>
                    <a v-else :href="item.link" target="_blank">
                      {{ $t(`footer.${item.name}`, item.name) }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="px-4 sm:px-6 md:px-0">
      <div
        class="flex flex-col gap-6 pt-8 mt-8 sm:px-6 border-t border-[#DDE6EF]"
      >
        <div class="flex gap-x-4 lg:hidden justify-center">
          <router-link :to="{ name: 'landing' }">
            <img class="h-10 md:h-12" :src="logo" alt="logo" />
          </router-link>
          <LanguageSwitch />
        </div>
        <div class="text-body-sm lg:text-body-md">
          © {{ $t("footer.copyright") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import logo from "../../assets/logo.svg";
import footerData from "../../data/footerData.json";
import LanguageSwitch from "@/components/common/LanguageSwitch.vue";
</script>
